module.exports = __webpack_public_path__ + "static/media/LogoutIcon.cdf8bfe8.svg";